import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { CalendarPage } from '@/components/calendar/calendar-page';

export const Route = createFileRoute('/calendar')({
  component: CalendarRoute,
});

function CalendarRoute() {
  const navigate = useNavigate();
  return (
    <CalendarPage
      onOpenBatch={(batchId) => {
        void navigate({ to: '/batches/$batchId', params: { batchId } });
      }}
      onOpenBlend={(blendId) => {
        void navigate({ to: '/blending/$blendId', params: { blendId } });
      }}
      onOpenRecipes={() => {
        void navigate({ to: '/recipes' });
      }}
    />
  );
}
